import { type HTMLAttributes, type ReactElement } from 'react';

import { cn } from '../lib/cn.js';

/**
 * Placeholder animado para estados de loading. Use em listas, cards e
 * linhas de tabela enquanto o fetch está em andamento.
 *
 * @example
 * {isLoading ? <Skeleton className="h-6 w-32" /> : <span>{data}</span>}
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactElement {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
